import { useEffect, useState } from "react";
import FaceRecognitionStepOne from "./FaceRecognitionStepOne";
import FaceRecognitionStepTwo from "./FaceRecognitionStepTwo";
import { useStyles } from "./formFaceRecognition.styles";
import { useSelector } from "react-redux";
import { VerifyImageExistsIdentification, VerifyImageExistsSelfie } from "../../Axios/getFaceRecognition";
import { Box, CircularProgress, Paper, Typography } from "@material-ui/core";
import logoThree from "../../assets/images/tres-logos-fn-azul-short2.svg";
import ModalCode from "./components/modalCode";

export default function FormFaceRecognition() {
  const { GlobalvaluesData } = useSelector((state) => state.GlobalStateAPP);
  const [isLoading, setIsLoading] = useState(true)
  const classes = useStyles();

  const [imageExists, setImageExists] = useState(false)
  const [documentId, setDocumentId] = useState("")
  const [documentType, setDocumentType] = useState("")
  const [codigo, setCodigo] = useState("")

  const [open, setOpen] = useState(false);

  const verifyExistsSelfie = async (identification) => {
    try {
      const result = await VerifyImageExistsSelfie(identification)
      return result.data
    } catch {
      return false
    }
  }

  const verifyExistsIdentification = async (identification) => {
    try {
      const result = await VerifyImageExistsIdentification(identification)
      return result.data
    } catch (error) {
      return false
    }
  }

  const verifyExistsImage = async (identification) => {
    setIsLoading(true)
    const existsSelfie = await verifyExistsSelfie(identification)
    const existsIdentification = await verifyExistsIdentification(identification)
    setImageExists(existsSelfie && existsIdentification)

    setTimeout(() => {
      setIsLoading(false)
    }, 750);
  }

  useEffect(() => {
    const identification = GlobalvaluesData?.cedula || GlobalvaluesData?.documento
    setDocumentId(identification)
    setDocumentType(GlobalvaluesData?.cedula ? "CEDULA" : "PASAPORTE")
    if (GlobalvaluesData) {
      verifyExistsImage(identification)
    }
  }, [GlobalvaluesData])

  if (isLoading) {
    return <CircularProgress size={100} color="inherit" className={classes.loading} />
  }

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        margin: "auto 0",
      }}
    >
      <Box width={"100%"} mt={3} style={{
        display: "flex",
        justifyContent: "center",
      }}>
        <img src={logoThree} alt="logo" className={classes.logo} />
      </Box>

      <Typography variant="h5" gutterBottom style={{ fontWeight: 600, color: "#00215C", textAlign: "center" }}>
        Sistema de Autenticación Facial
      </Typography>

      <Box style={{ maxWidth: 600, width: "100%" }}>
        <Paper
          variant="outlined"
          style={{
            textAlign: "center",
            color: "#1976d2",
            marginBottom: 24,
            padding: 16,
            borderRadius: 8,
          }}
        >
          Para obtener su certificado debe realizar el proceso de
          autenticación facial.
        </Paper>

        {imageExists ? <FaceRecognitionStepTwo documentType={documentType} identification={documentId} setCodigo={setCodigo} setOpen={setOpen} /> :
          <FaceRecognitionStepOne documentType={documentType} identification={documentId} setCodigo={setCodigo} setOpen={setOpen} />}
      </Box>
      {open && (
        <ModalCode codigo={codigo} openModal={open} setOpen={setOpen} />
      )}
    </Box>
  );
}
